// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"ddc953bb00ad80f5e746","303":"e93411573920ef2e5ab1","495":"a53dfcbaa2127093804d"}[chunkId] + ".js";
};